<template>
    <div :class="$style['integral-goods-message']">
        <pt-sub-title title="商品信息"></pt-sub-title>
        <table>
            <pt-form-list-item label="优惠券：" v-if="goodsData.coupons">
              <div :class="$style['coupon-table-div']" class="page-background">
                <table :class="$style['coupon-table']">
                  <th>
                  <td>优惠券名称</td>
                  <td>使用形式</td>
                  <td>优惠形式</td>
                  <td>内容</td>
                  <td>有效期</td>
                  <td>状态</td>
                  <td>兑换数量</td>
                  </th>
                  <tr v-for="(item,index) in goodsData.coupons" :key="index">
                    <td>{{item.couponData&&item.couponData.name}}</td>
                    <td>{{item.used_type}} </td>
                    <td>{{item.discountType}}</td>
                    <td>
                      <div>{{item.discount}}</div>
                      <div>满{{item.thresholdOfAmount}}元可使用</div>
                    </td>
                    <td>{{item.startTime }}至{{item.endTime}} </td>
                    <td>{{item.coupon_status}}</td>
                    <td>{{item.couponAmount}}</td>
                  </tr>
                </table>
              </div>
            </pt-form-list-item>
            <pt-form-list-item label="基因商品：" v-if="showGoodsTable">
              <div class="page-background">
                  <table  :class="$style['goods-table']">
                  <tr>
                      <td>商品名称</td>
                      <td>价格（元）</td>
                  </tr>
                  <tr >
                      <td>{{goods_list.goodsDTO&&goods_list.goodsDTO.goodsData&&goods_list.goodsDTO.goodsData.name}}</td>
                      <td>{{goods_list.final_price}}</td>
                  </tr>
            </table>
              </div>
            </pt-form-list-item>
            <pt-form-list-item label="商品名称：">{{goodsData.name}}</pt-form-list-item>
            <pt-form-list-item label="商品描述：">{{goodsData.description }}</pt-form-list-item>
            <pt-form-list-item label="商品分组：">{{goodsData.groupName }}</pt-form-list-item>
            <pt-form-list-item label="商品图：">
              <pt-img :class="$style['goods-pictrue']" :src="goodsData.mainPicture" title="商品图.png" alt="商品图.png" />
            </pt-form-list-item>
            <pt-form-list-item label="广告位图片：">
              <pt-img :class="$style['advertising-pictrue']" :src="goodsData.bannerPicture" title="广告位图片.png" alt="广告位图片.png" />
            </pt-form-list-item>
            <!-- <pt-form-list-item label="标签：">{{goodsData.tags }}</pt-form-list-item> -->
        </table>
    </div>
</template>
<script>
import { isEmptyObject } from 'utils/formUtils'
export default {
  props: {
    goodsData: Object,
    mallGoods: Object
  },
  data () {
    return {
      goods_list: {}
    }
  },
  watch: {
    mallGoods: {
      handler (val) {
        this.goods_list = val
      }
    }
  },
  computed: {
    // 是否显示商品列表（已选择商品）
    showGoodsTable () {
      return this.goods_list && !isEmptyObject(this.goods_list) && this.goodsData.type === 'GENE'
    }
  }
}
</script>
<style module lang="less">
  .coupon-table-div {
    margin-top:20px;
    padding: 0 .2rem .2rem;
  }
  .coupon-table {
    display: table !important;
    min-width: 13rem;
    border-collapse: collapse !important;

    th,
    tr {
      width: 100% !important;
      max-width: 100% !important;
      display: table-row !important;
      padding: 0 !important;
      list-style-type: none;
      justify-content: center !important;
      border-bottom: 1px solid #C6C9D3;
      color: #5B5B5B !important;
    }

    td {
      color: #5B5B5B !important;
      text-align: center;
      justify-content: flex-start !important;
      padding: 10px;
    }
  }

  .goods-table{
    display: table !important;
    width: 100%;
    border-collapse: collapse !important;
     th,tr{
        width: 100%!important;
        max-width: 100%!important;
        display: table-row;
        padding: 0!important;
        list-style-type:none;
        border-bottom: 1px solid #C6C9D3;
        color: #818181
    }
    td{
        text-align: center;
        padding: 10px;
    }
  }
  .goods-pictrue{
    width: 100px;
    border-radius: 0.05rem;
  }
  .advertising-pictrue{
    width: 350px;
    height: 128px;
    border-radius: 0.05rem;
  }
</style>
